import React from 'react';
import styles from '../styles.module.scss';
import { CurrentTeamSidebarTypesEnum } from '../documentTeamSidebarContainer';

interface ToggleButtonProps {
  setCurrentTeamSidebarType(value: CurrentTeamSidebarTypesEnum): void;
  currentTeamSidebarType: CurrentTeamSidebarTypesEnum;
}

const TeamToggleButtons = ({ setCurrentTeamSidebarType, currentTeamSidebarType }: ToggleButtonProps) => {
  return (
    <div className={styles.tabToggleContainer}>
      <button
        className={`${styles.tabButton} ${currentTeamSidebarType === CurrentTeamSidebarTypesEnum.counterparty ? styles.active : ''}`}
        onClick={() => setCurrentTeamSidebarType(CurrentTeamSidebarTypesEnum.counterparty)}
      >
        Counterparty
      </button>
      <button
        className={`${styles.tabButton} ${currentTeamSidebarType === CurrentTeamSidebarTypesEnum.dealteam ? styles.active : ''}`}
        onClick={() => setCurrentTeamSidebarType(CurrentTeamSidebarTypesEnum.dealteam)}
      >
        My Deal Team
      </button>
    </div>
  );
};

export default TeamToggleButtons;
